<script>
import { pricify } from '@utils/currency'

export default {
  props: {
    amount: {
      type: Number,
      required: true,
    },
    orderNumber: {
      type: String,
      required: true,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    selectedTotal: {
      type: Number,
      default: null,
    },
    serviceCharge: {
      type: Number,
      default: null,
    },
    splitServiceCharge: {
      type: Number,
      default: null,
    },
    tableNumber: {
      type: Number,
      required: true,
    },
    tip: {
      type: Number,
      default: null,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    computedServiceCharge() {
      return pricify(this.splitServiceCharge || this.serviceCharge)
    },
    computedSubtotal() {
      const total = parseFloat(this.selectedTotal || this.total)
      const serviceCharge = parseFloat(this.computedServiceCharge || 0)
      const tip = parseFloat(this.tip || 0)
      const subtotal = total + serviceCharge + tip
      if (subtotal === total) return null
      return pricify(subtotal)
    },
    computedTip() {
      return pricify(this.tip)
    },
    computedTotal() {
      return pricify(this.selectedTotal || this.total)
    },
  },
}
</script>

<template>
  <div :class="$style.summary">
    <!-- Order number -->
    <div :class="$style.row">
      <h4>Order:</h4>
      <h4>{{ orderNumber }}</h4>
    </div>

    <!-- Table -->
    <div :class="$style.row">
      <h4>Table:</h4>
      <h4>#{{ tableNumber }}</h4>
    </div>

    <!-- Number of items -->
    <div :class="$style.row">
      <h4>Number of items:</h4>
      <h4 v-if="selectedItems">{{ selectedItems.length }}</h4>
      <h4 v-if="!selectedTotal">{{ amount }}</h4>
    </div>

    <!-- Item total -->
    <div v-if="total" :class="$style.row">
      <h4>Item total:</h4>
      <h4>£{{ computedTotal }}</h4>
    </div>

    <!-- Service charge -->
    <div v-if="serviceCharge" :class="$style.row">
      <h4>Service charge:</h4>
      <h4>£{{ computedServiceCharge }}</h4>
    </div>

    <!-- Tip -->
    <div v-if="tip" :class="$style.row">
      <h4>Tip:</h4>
      <h4>£{{ computedTip }}</h4>
    </div>

    <!-- Subtotal -->
    <div v-if="computedSubtotal" :class="$style.row">
      <h4>Subtotal:</h4>
      <h4>£{{ computedSubtotal }}</h4>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.summary {
  width: 100%;
  padding: 1rem 2rem;
  margin-bottom: 1rem;
}

.row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem 0;
}
</style>
